(function ($) {
  'use strict';

  /**
   * Date Countdown Tickers
   */

  var $countdown_bar = $('.js-date-countdown');

  $countdown_bar.each(function () {
    $(this).dateCountdown();
  });

})(jQuery);
